<template>
  <el-container class="home-container">
    <!-- 侧边栏 -->
    <el-aside :width="isCollapse ? '64px' : '200px'">
      <!-- <div class="toggle-button" @click="toggleCollapse">|||</div> -->
      <div class="logo-box">
        <img src="../assets/logo-white.png" alt="">
        <div>上海市英才进修学院</div>
      </div>
      <!-- 侧边栏菜单区域 -->
      <el-menu background-color="#1F41A8" active-background-color="#346AFF" text-color="#fff" active-text-color="#fff" unique-opened :collapse="isCollapse" :collapse-transition="false" router :default-active="activePath">
        <div :index="item.id + ''" v-for="item in menulist" :key="item.id">

          <!-- 一级菜单 -->
          <el-submenu v-if="item.children&&item.children.length>0" :index="item.id + ''">
            <!-- 一级菜单的模板区域 -->
            <template slot="title">
              <!-- 图标 -->
              <i :class="item.icon"></i>
              <!-- 文本 -->
              <span>{{ item.name }}</span>
            </template>
            <!-- 二级菜单 -->
            <el-menu-item :index="'/' + subItem.value" v-for="subItem in item.children" :key="subItem.id" @click="saveNavState( subItem)">
              <template slot="title">
                <!-- 图标 -->
                <!-- <i :class="iconsObj[subItem.name]"></i> -->
                <!-- 文本 -->
                <span style=" margin-left: 14px;">{{ subItem.name }}</span>
              </template>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else @click="saveNavState(item)" :index="'/' + item.value">
            <template slot="title">
              <!-- 图标 -->
              <i :class="item.icon"></i>
              <!-- 文本 -->
              <span>{{ item.name }}</span>
            </template>
          </el-menu-item>
        </div>
      </el-menu>
    </el-aside>
    <!-- 页面主体区域 -->
    <el-container>

      <!-- 头部区域 -->
      <el-header>

        <!-- 面包屑导航区域 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }" v-if="breadcrumbList.length" >首页</el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item,index) in breadcrumbList" :key='index'>{{item}}</el-breadcrumb-item>

        </el-breadcrumb>

        <!-- 用户信息 -->

        <span class="el-dropdown-link">
          <span @click="drawer=true">  
          <img class="avatar" :src="srcPic" >
          <span >
            {{userInfo.username}}
          </span>
          <i class="el-icon-arrow-down"></i>
          </span>
          <el-button type="primary" round size="mini" @click="logout">退出</el-button>
        </span>

      </el-header>
      <!-- 右侧内容主体 -->
      <el-main>
        <!-- 路由占位符 -->
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-drawer :with-header="false" :visible.sync="drawer" :direction="direction" :wrapperClosable='false'>
      <ul class="info-list">
        <li class="info-item" @click="showUserInfoDialog">
          <span class="info-key">头像</span><span class="info-val"><img :src="srcPic" alt=""></span>
        </li>
        <li class="info-item" >
          <span class="info-key">昵称</span><span class="info-val">{{userInfo.username}}</span>
        </li>
        <li class="info-item" @click="showUserInfoDialog">
          <span class="info-key">手机号码</span><span class="info-val">{{userInfo.mobile}} <i class="el-icon-arrow-right"></i></span>
        </li>
        <li class="info-item" @click="showUserInfoDialog">
          <span class="info-key">邮箱</span><span class="info-val">{{userInfo.email}} <i class="el-icon-arrow-right"></i></span>
        </li>
        <!-- <li class="info-item" @click="showUserInfoDialog">
          <span class="info-key">职位</span><span class="info-val">{{userInfo.role}} <i class="el-icon-arrow-right"></i></span>
        </li> -->
        <li class="info-item" @click="showPwdDialog">
          <span class="info-key">修改密码</span><span class="info-val"><i class="el-icon-arrow-right"></i></span>
        </li>

      </ul>
      <el-button type="primary" round @click="drawer=false">确定</el-button>
    </el-drawer>
    <!-- 修改用户信息的对话框 -->
    <el-dialog title="修改个人信息" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed" :close-on-click-modal='false'>
      <el-form :model="editForm" :rules="formRules" ref="editFormRef" label-width="60px">
        <!-- <el-form-item label="昵称" prop="username" class="col2">
          <el-input v-model="editForm.username" disabled></el-input>
         
        </el-form-item> -->
          <el-form-item label="邮箱" prop="email"  class="col2">
            <el-input v-model="editForm.email"></el-input>
             <el-form-item label="手机" prop="mobile">
            <el-input v-model="editForm.mobile"></el-input>
          </el-form-item>
          </el-form-item>
        <!-- <el-form-item label="密码" prop="password" class="col2">
          <el-input v-model="editForm.password" type="password"></el-input>
        </el-form-item> -->

        <el-form-item label="头像" prop="userPic">
          <ul class="header-list">
            <li :class="{'header-item':true,'clicked':editForm.userPic ==i} " v-for=" i in 6" :key='i' @click="selectPic(i,editForm)">
              <img :src="require('../assets/img/'+i+'.png')" alt="">
              <i class="el-icon-check"></i>
            </li>
          </ul>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUser">保 存</el-button>
      </span>
    </el-dialog>
     <mod-pwd :show='modifyPwdVisible'  @dialogClose="modifyPwdVisible=false"></mod-pwd>
  </el-container>
</template>

<script>
import * as loginApi from '../api/loginAPI'
import * as userApi from '../api/userAPI'
import md5 from 'js-md5'
import updatePassword from '../components/subcomponents/update_password.vue'
export default {
  data() {
    var validatorPhone = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    return {
      drawer: false,
      direction: 'rtl',
      // 左侧菜单数据
      menulist: [],
     // breadcrumbList: [],
      // 是否折叠
      isCollapse: false,
      // 被激活的链接地址
      activePath: "",
      userInfo: {},
      editForm: {},
      editDialogVisible: false,
      modifyPwdVisible: false,
      formRules: {
        mobile: [{ required: true, validator: validatorPhone, trigger: "blur", },],
        password: [{ required: true, message: "请输入密码", trigger: "blur", },
        { min: 6, message: '长度需要超过6位', trigger: 'blur' }],
        email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }],
        // workNumber: [{ required: true, message: "请输入工号", trigger: "blur", },],
        enableState: [{ required: true, message: "请选择状态", trigger: "blur", },],

      },
      srcPic: "",
    };
  },
  async created() {
    let user_info = await this.$store.getters.getUserInfo
   
    console.log('首页刷新', user_info,this.$route.path);
    if (!user_info) {
      this.$router.push("/login");
    }
    this.userInfo = { ...user_info }
    this.editForm = user_info
    this.srcPic = require('../assets/img/' + user_info.userPic + '.png')
    await this.getMenuList();
    this.activePath = window.sessionStorage.getItem("activePath");
  },
  mounted() {

  },
  methods: {
    async logout() {
      let res = await loginApi.logout()
      if (res.flag) {
        window.sessionStorage.clear();
        window.localStorage.clear();
       
        this.$router.push("/login");
      }
    },
    async clear() {
      window.localStorage.clear();
      this.$message.success('清除缓存成功！')
    },
    // 获取所有的菜单
    async getMenuList() {
      let res = await userApi.getMenuList()
      if (res.flag) {
        let secondList = res.data.filter(item => item.type == '2ndMenu')
        //具体访问路径
        let second = secondList.map(m => "/" + m.value)
        //每次刷新都会走这个方法请求能访问的路径，并加路径放到vuex中，避免暴露
        this.$store.commit('saveRouterList',  res.data)
        //左侧菜单栏
        let first = res.data.filter(item => item.type == '1stMenu')
        first.map(menu => {
          menu.children = res.data.filter(item => item.pid == menu.id && item.show != 0)
        })
        this.menulist = first
       
      }
    
    },
    // 点击按钮，切换菜单的折叠与展开
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    // 保存链接的激活状态
    saveNavState(item) {
      window.sessionStorage.setItem("activePath", item.vlaue);
      this.activePath = item.vlaue;
      


    },
    showUserInfoDialog() {
      this.editDialogVisible = true
    },
    showPwdDialog() {
      this.modifyPwdVisible = true
    },
    editDialogClosed() {
      this.editForm = { ...this.userInfo }
    },
    editUser() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;

        let { id, create_time, ...param } = { ...this.editForm }
        if (param.password != this.userInfo.password) {
          let encode = md5(param.password);
          param.password = md5(param.password + encode.substring(5, 10))
        } else {
          delete param.password
        }

        userApi.update(param).then(res => {
          if (res.flag) {
            this.$message.success('更新个人信息成功！')
            this.userInfo = { ...this.editForm }
            this.$store.commit("saveUserInfo", this.editForm);
            this.srcPic = require('../assets/img/' + this.editForm.userPic + '.png')
            // this.getUserList()
            this.editDialogVisible = false
          } else {

          }
        })
      })
    },
    selectPic(index, form) {
      form.userPic = index
    },
  },
  components:{
    "mod-pwd":updatePassword
  },
  computed:{
    breadcrumbList(){
      return this.$store.getters.getBreadcrumbList
    }
  }
};
</script>

<style lang="less" >
.home-container {
  height: 100%;
  .el-header {
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    padding-left: 0;
    align-items: center;
    color: #fff;
    font-size: 20px;
    box-shadow: 0px 10px 20px 0px rgba(0, 0 ,0 ,0.05);
    z-index: 1;
    height: 50px !important;
    > div {
      margin-bottom: 0;
      margin-left: 20px;
    }
  }

  .el-aside {
    background-color: #1f41a8;
    .logo-box {
      text-align: center;
      color: #fff;
      padding: 20px 0px;
      font-weight: bold;
      font-size: 14px;
      img {
        margin-bottom: 10px;
      }
    }
    .el-menu {
      border-right: none;
      i {
        width: 24px;
        text-align: center;
        vertical-align: middle;
        display: inline-block;
      }
      .el-menu-item.is-active {
        background-color: #346aff !important;
      }
      .el-menu-item:hover {
        background-color: #346aff !important;
      }
      .el-submenu__title:hover {
        background-color: #346aff !important;
      }
      .el-submenu__title {
        i {
          color: #fff !important;
        }
      }
      .el-menu-item {
        i {
          color: #fff !important;
        }
      }
    }
  }
.el-container{
  // min-width: auto !important;
}
  .el-main {
    background-color: #f5f5fc;
    // padding-bottom:0;

  }

  .iconfont {
    margin-right: 10px;
  }

  .toggle-button {
    background-color: #4a5064;
    font-size: 10px;
    line-height: 24px;
    color: #fff;
    text-align: center;
    letter-spacing: 0.2em;
    cursor: pointer;
  }

  .el-dropdown-link {
    display: flex;
    align-items: center;
    color: #808081;
    white-space: nowrap;
    font-size: 13px;
    cursor: pointer;
    >span{
      display: flex;
      align-items: center;
    }
    img {
      width: 30px;
      margin-right: 10px;
    }
    button {
      background: #5373f5;
      border: none;
      padding: 5px 20px;
      margin-left: 10px;
    }
    .el-icon-arrow-down{
      margin-left: 10px;
    }
  }
  .info-list {
    padding: 0;
    margin-top: 0;
    .info-item {
      cursor: pointer;
      padding: 20px 20px;
      border-bottom: 1px solid #e1e1e1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .info-val {
        color: #999;
      }
      img {
        width: 50px;
      }
    }
    &:last-child {
      cursor: pointer;
    }
  }
  .el-drawer {
    min-width: 300px;
    max-width: 360px;
    .el-drawer__body {
      button {
        position: absolute;
        bottom: 50px;
        width: 80%;

        padding: 0 20p;
        transform: translate(-50%, 0px);
        left: 50%;
        transform: translate(-50%);
      }
      .el-icon-arrow-right {
        cursor: pointer;
      }
    }
  }
  .el-form-item.col2 {
    .el-form-item__content {
      display: flex;
      .el-input {
        width: 230px;
      }
    }
  }
  .el-dialog {
    min-width: 600px;

    .header-list {
      display: flex;
      padding-left: 0px;
      flex-wrap: wrap;
      .header-item {
        margin-left: 20px;
        margin-bottom: 20px;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        position: relative;
        box-sizing: border-box;
        img {
          width: 60px;
        }
        .el-icon-check {
          display: none;
        }
      }
      .header-item.clicked {
        border: 2px solid #5fbdfe;
        .el-icon-check {
          display: block;
          position: absolute;
          font-size: 30px;
          font-weight: bolder;
          color: #10ff00;
          bottom: -6px;
          right: -2px;
        }
      }
    }
  }
}
</style>
